module.exports = __webpack_public_path__ + "img/m-logo.92b06fdd.png";